import React from 'react';
import './style.css';

const Loader = () => (
  <div className="loader-container">
    <div className="loader-spinner"></div>
  </div>
);

export default Loader;